// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"styles_tableRow__1v18D","link":"styles_link__SAuop"};